import { Button, Tooltip } from "antd";
import React from "react";
import { ImMagicWand } from "react-icons/im";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { isAIAssistantDisabledSelector } from "views/Orgs/selector";

const MagicButton = ({
  shape = "circle",
  size = "middle",
  ghost = false,
  onClick,
  text,
  icon,
  type = 'default',
  disabled = false,
  loading = false,
  tooltipTitle = "",
  tooltipPlacement,
  mode="primary"
}) => {
  console.log("MagicButton -> tooltipTitle", shape, disabled)
  const isAIAssistantDisabled = useSelector(isAIAssistantDisabledSelector())
  console.log("isAIAssistantDisabled ===>", isAIAssistantDisabled);
  if (isAIAssistantDisabled && isAIAssistantDisabled.message) {
    tooltipTitle = tooltipTitle.concat(" - ").concat(isAIAssistantDisabled.message)
    // .concat(" - Learn more") // TODO: learn more to open AI features modal -  learn more modal if reason is subject disable or standard plan
  }
  return (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
      <Button
        loading={loading}
        type={type}
        disabled={isAIAssistantDisabled.disabled || disabled}
        className={`${mode === "primary" ? "magic-button-primary" : "magic-button-subtle"} ${shape === "circle" ? "magic-button-circle" : ""}`}
        shape={shape}
        size={size}
        ghost={ghost}
        icon={icon ? icon : <ImMagicWand />}
        onClick={onClick}
      >
        {text && <>{text}</>}
      </Button>
    </Tooltip>
  );
};

export default MagicButton;
